import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    userIsInternal: boolean;
  }>()
  .create(({ theme, userIsInternal }) => ({
    dashboardPageContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    dashboardLargeItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 4',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardMediumItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: userIsInternal ? 'span 3' : 'span 4',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardXLargeItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: userIsInternal ? 'span 6' : 'span 8',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardServiceTickets: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(2, minmax(0, 14vh))',
      gap: '1.5rem',
      height: '50%',
      [theme.breakpoints.down('xl')]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'repeat(6, minmax(auto, 200px))'
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(3, minmax(auto, 300px))'
      }
    },
    dashboardThreatTickets: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(5, minmax(0, 14vh))',
      gap: '1.5rem',
      height: '100%',
      [theme.breakpoints.down('xl')]: {
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gridTemplateRows: userIsInternal
          ? 'repeat(14, minmax(auto, 200px))'
          : 'repeat(12, minmax(auto, 200px))'
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridTemplateRows: userIsInternal
          ? 'repeat(9, minmax(auto, 300px))'
          : 'repeat(8, minmax(auto, 300px))'
      }
    },
    dashboardSmallItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 1',
      gridColumn: 'span 2',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 1'
      }
    },
    ticketTableHeader: {
      width: '100%',
      borderBottom: `1px solid ${theme.vars.palette.divider}`,
      height: '3rem',
      marginLeft: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.vars.palette.background.elevation2
    },
    ticketsTable: {
      '& .ag-header-container': {
        backgroundColor: theme.vars.palette.background.elevation2,
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.5rem'
      }
    }
  }));

export default useStyles;
